import { toast } from "react-hot-toast";

export const successToast = (message) => {
  toast.success(message, {
    // custom styles for react-hot-toast that could be called anywhere
    style: {
      background: "#009689",
      padding: "16px",
      color: "#ffffff",
    },
    iconTheme: {
      primary: "#009689",
      secondary: "#ffffff",
    },
    duration: 5000,
  });
};
/**
 * A toast that stays up until dismissed, for work with no progress to report.
 * Returns the toast id to pass to dismissToast.
 */
export const loadingToast = (message) =>
  toast.loading(message, {
    style: {
      background: "#009689",
      padding: "16px",
      color: "#ffffff",
    },
  });

export const dismissToast = (toastId) => toast.dismiss(toastId);

export const errorToast = (message) => {
  toast.error(message, {
    // custom styles for react-hot-toast that could be called anywhere
    style: {
      background: "#F73131",
      padding: "16px",
      color: "#ffffff",
    },
    iconTheme: {
      primary: "#F73131",
      secondary: "#ffffff",
    },
    duration: 5000,
  });
};
